import { useContext } from 'react'

import { Box, Icon, Text } from '@fairfashion/design-system'

import { AuditItemDetailsContext } from '../../audit-item-details.context'

import * as Styles from './item-header.styles'

export const ItemHeader = () => {
  const { traceability } = useContext(AuditItemDetailsContext)

  const item = traceability?.[0]

  return (
    <Styles.Card>
      <Box width="100%" alignItems="center">
        <Box flex={1} alignItems="center" gap={2}>
          <Styles.IconContainer>
            <Icon name="shapes" size={24} color="purple" />
          </Styles.IconContainer>
          <Text fontWeight={500}>Dados do item</Text>
        </Box>
      </Box>
      <Styles.Container width="100%">
        <Box direction="column">
          <Text size="small" color="grey_3">
            Item
          </Text>
          <Styles.DescriptionText size="small" fontWeight={500} width="300px">
            {item?.description}
          </Styles.DescriptionText>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Quantidade
          </Text>
          <Text size="small" fontWeight={500}>
            {item?.quantity} {item?.taxUnit}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Código
          </Text>
          <Text size="small" fontWeight={500}>
            {item?.code}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            NF
          </Text>
          <Text size="small" fontWeight={500}>
            {item?.invoice?.code}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Cliente
          </Text>
          <Text size="small" fontWeight={500}>
            {item?.client?.name}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            CNPJ
          </Text>
          <Text size="small" fontWeight={500}>
            {item?.client.taxId}
          </Text>
        </Box>
      </Styles.Container>
    </Styles.Card>
  )
}
